<template>
  <div
    class="min-h-0 min-w-0 overflow-auto bg-n-background w-full px-4 sm:px-6 lg:px-8"
  >
    <div class="min-w-0 max-w-5xl mx-auto pb-20 pt-6 md:pb-8">
      <router-view />
    </div>
  </div>
</template>
